(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const label = document.currentScript.dataset.videoLabel;
  const original = new Map();
  const productInfo = document.querySelector('product-info');
  const title = productInfo?.querySelector('.product__title');
  const cart = document.querySelector('cart-items');
  const footer = document.querySelector('footer.footer');
  if (!title && !cart) return;
  const dock = document.createElement('div');
  dock.className = 'purchase-help-inline';
  if (title) title.before(dock);
  else if (footer) footer.prepend(dock);
  else return;
  const move = (element) => {
    if (!original.has(element)) {
      original.set(element, { parent: element.parentNode, next: element.nextSibling });
    }
    dock.append(element);
  };
  const restore = () => {
    original.forEach(({ parent, next }, element) => {
      if (next?.parentNode === parent) parent.insertBefore(element, next);
      else parent.append(element);
    });
  };
  const video = document.getElementById('floatingVideo');
  const thumbnail = video?.querySelector('video');
  const wasAutoplay = thumbnail?.autoplay;
  if (video) {
    video.setAttribute('role', 'button');
    video.setAttribute('tabindex', '0');
    video.setAttribute('aria-label', label);
    video.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        video.click();
      }
    });
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.classList.add('purchase-video-icon');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M8 5v14l11-7z');
    path.setAttribute('fill', 'currentColor');
    icon.append(path);
    video.append(icon);
  }
  const update = () => {
    if (!mobile.matches) {
      restore();
      if (thumbnail && wasAutoplay) {
        thumbnail.autoplay = true;
        thumbnail.play().catch(() => {});
      }
      dock.hidden = true;
      return;
    }
    dock.hidden = false;
    if (video) {
      move(video);
      const thumbnail = video.querySelector('video');
      if (thumbnail) {
        thumbnail.autoplay = false;
        thumbnail.pause();
      }
    }
    const whatsapp = document.getElementById('whatsapp-widget-root');
    if (whatsapp) move(whatsapp);
  };
  mobile.addEventListener('change', update);
  update();
  if (!document.getElementById('whatsapp-widget-root')) {
    const observer = new MutationObserver(() => {
      if (document.getElementById('whatsapp-widget-root')) {
        update();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }
})();
